/**
 * Component Entry
 *
 */

import FormLabel from './FormLabel'
export default FormLabel
export * from './FormLabel'
